<template>
  <div class="row home-insurance-form">
    <div class="col-md-12">
      <FormOne v-if="step === 1" />
      <FormTwo v-if="step === 2" />
      <FormThree v-if="step === 3" />
      <FormFour v-if="step === 4" />
      <FormFive v-if="step === 5" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import FormOne from "./components/FormOne.vue";
import FormTwo from "./components/FormTwo.vue";
import FormThree from "./components/FormThree.vue";
import FormFour from "./components/FormFour.vue";
import FormFive from "./components/FormFive.vue";

export default {
  name: "HomeApplication",
  components: {
    FormOne,
    FormTwo,
    FormThree,
    FormFour,
    FormFive,
  },
  computed: {
    ...mapState(["step"]),
  },
};
</script>

<style>
.required {
  color: #980000;
}

.form-container {
  min-height: 420px;
}

.e-wrapper {
  height: 2rem;
}

.step-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
}

.home-insurance-form .mb-3 {
  margin-bottom: 1rem;
}
</style>
